define('collections/Podio.Collections.AccountProviders',['require','lib/backbone/Backbone.PodioCollection','lib/Podio.Routes'],function(require) {

  var PodioCollection = require('lib/backbone/Backbone.PodioCollection');
  var routes = require('lib/Podio.Routes');

  return PodioCollection.extend({

    initialize: function(models, options) {
      this.url = routes.available_linked_account_index_path();
    },

    getAvailableFor: function(capability) {
      return this.fetch({
        url: routes.available_linked_account_index_path( { capability : capability }),
        reset: true
      });
    },

    getByName: function(name) {
      return this.find(function(item) {
        return item.get('name') === name;
      });
    }

  });

});

